import { IoWarningOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import Toaster from "./../../../../../components/common/Toaster";
import accountService from "../../../../../services/accountService";

const DeleteEmail = ({ data, onClose, isLoading, setLoading, onSuccess }) => {
  const handleDelete = async () => {
    try {
      setLoading(true);

      await accountService.deleteEmailAsync(data.id);

      onSuccess(data);
      Toaster.Success("Email deleted successfully");
      setLoading(false);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <div className="text-center">
        <IoWarningOutline className="text-red-500 mx-auto text-4xl" />
        <p className="text-gray-400 text-sm mt-5">
          Are you sure you want to delete{" "}
          <span className="text-gray-500">{data && data.email}</span>?
        </p>
      </div>
      <div className="grid grid-cols-3 mt-12 space-x-2">
        <div className="col-span-1">
          <button
            className="text-gray-400 text-sm button float-right focus:outline-none"
            onClick={() => onClose()}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-2">
          <button
            className="button bg-red-500 text-white disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
            onClick={() => handleDelete()}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            Yes, delete it
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteEmail;
